import {EntityField} from "../../../core/genericdocuments/EntityField";
import {EntityFieldDataType} from "../../../core/genericdocuments/EntityFieldDataType";
import {EntityFieldsDescriptor} from "../../../core/genericdocuments/EntityFieldsDescriptor";
import {ZaKabinetDocument} from "./ZaKabinetDocument";
import {baseDocumentFields} from "../BaseDocumentFields";
import {LookupEntities} from "../../../core/genericdocuments/ReferenceDetails";

export const zaKabinetDocumentFields: IntercateKeysMap<ZaKabinetDocument, EntityField<ZaKabinetDocument>> = {
	sectorId: {
		name: "sectorId", dataType: EntityFieldDataType._reference, label: "Sektor",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Departments
		},
		validator: { required: true },
		sortable: true
	}
}

const documentFieldsArray: Array<EntityField<ZaKabinetDocument>> = [
	zaKabinetDocumentFields.sectorId
]

export const zaKabinetDocumentFieldsDescriptor: EntityFieldsDescriptor<ZaKabinetDocument> = {
	listFields: documentFieldsArray,
	createFormFields: documentFieldsArray,
	updateFormFields: documentFieldsArray
}
